module.exports = __webpack_public_path__ + "media/images/c02-b8ea14f7a057f1b3863265e15236f26b.svg";